import React from "react";
import Navigationbar from "../layouts/navigationbar";

function Home() {
  return (
    <>
      <Navigationbar openStatus={true} />
    </>
  );
}

export default Home;
